import enEN from './locale/enEN';
import deDE from './locale/deDE';

export default {
  enEN,
  deDE,
};